import React, { useState } from 'react';
import { Automation } from '@/types/automation';
import { initializeAutomations } from '@/services/automation';
import { getAutomationByEnvironment } from '@/services/automation/query';

export default function AutomationsTest() {
  const [status, setStatus] = useState('Ready to test');
  const [automations, setAutomations] = useState<Automation[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleTest = async () => {
    setIsLoading(true);
    setStatus('Initializing automations...');

    try {
      await initializeAutomations();
      setStatus('✅ Initialization successful');
      
      const productionAutomations = await getAutomationByEnvironment('production');
      setAutomations(productionAutomations);
      
      if (productionAutomations.length > 0) {
        setStatus(`✅ Found ${productionAutomations.length} automations`);
      } else {
        setStatus('⚠️ No automations found after initialization');
      }
    } catch (error: any) {
      setStatus(`❌ Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="p-3 bg-gray-50 rounded border">
        <p className="font-mono text-sm">{status}</p>
      </div>
      
      <button
        onClick={handleTest}
        disabled={isLoading}
        className="w-full bg-primary text-dark px-4 py-2 rounded hover:bg-primary-hover transition-colors disabled:opacity-50"
      >
        {isLoading ? 'Testing...' : 'Test Automations'}
      </button>

      {automations.length > 0 && (
        <div className="space-y-4">
          <h3 className="font-medium">Found Automations:</h3>
          {automations.map((automation) => (
            <div key={automation.id} className="p-3 bg-gray-50 rounded border">
              <p className="font-medium">{automation.description}</p>
              <p className="text-sm text-gray-600">ID: {automation.id}</p>
              <p className="text-sm text-gray-600">Environment: {automation.environment}</p>
              <p className="text-sm text-gray-600 break-all">URL: {automation.url}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}